import React from "react";
import { IAddUserAddressInput } from "muminsmart-utils";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import AddressForm, { AddressFormProps } from "./AddressForm";

type AddressFormModalProps = {
  open: boolean;
  onOpenChange: React.Dispatch<React.SetStateAction<boolean>>;
  editingAddressId: string | null;
  addressForm: IAddUserAddressInput;
  isAddressMutating: boolean;
  onSubmit: AddressFormProps["onSubmit"];
};

export default function AddressFormModal({
  open,
  onOpenChange,
  editingAddressId,
  addressForm,
  isAddressMutating,
  onSubmit,
}: AddressFormModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-4xl max-h-[90dvh] flex flex-col max-w-xl">
        <DialogHeader>
          <DialogTitle>
            {editingAddressId ? "Edit Address" : "Add Address"}
          </DialogTitle>
          <DialogDescription>
            Fill in the delivery details for this order.
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto">
          <AddressForm
            initialValues={addressForm}
            isSubmitting={isAddressMutating}
            submitLabel={editingAddressId ? "Update Address" : "Add Address"}
            onSubmit={onSubmit}
          />
        </div>

        {/* <DialogFooter className="pt-0">
          <DialogClose asChild>
            <Button variant="secondary" className="rounded-full">Close</Button>
          </DialogClose>
        </DialogFooter> */}
      </DialogContent>
    </Dialog>
  );
}
